import styled from 'styled-components';

import { Button } from '@hivebrite/design-system/Button';

import ApplyToBeMentorModal from 'hb-react/frontoffice/apps/Mentorships/components/Modals/ApplyToBeMentorModal';
import { REJECTED_CAN_REAPPLY } from 'hb-react/frontoffice/apps/Mentorships/constants';
import {
  convertMentorStatus,
  getMentorLabel,
} from 'hb-react/frontoffice/apps/Mentorships/utils';
import { DefaultLink } from 'hb-react/frontoffice/components/Link';
import { getMentorProfile } from 'hb-react/shared/apps/Mentorships/utils/mentorProfiles';

const getMentorshipsHeaderControls = ({
  appPageConfig,
  currentUser,
  currentNetwork,
  topic,
  customAttributesList,
  isPreview,
}) => {
  const mentorLabel = getMentorLabel(currentNetwork, topic);

  const mentorProfile = getMentorProfile({
    mentorProfiles: currentUser?.current_mentor_profiles,
    networkId: currentNetwork?.id,
    topicId: topic?.id,
  });
  const mentorStatus = mentorProfile?.status;
  let mentorStatusButton = null;

  if (mentorStatus && ![REJECTED_CAN_REAPPLY].includes(mentorStatus)) {
    mentorStatusButton = (
      <Button isDisabled>
        {s__('Mentorships|%{mentorLabel} status: %{mentorStatus}').i__({
          mentorLabel,
          mentorStatus: convertMentorStatus(mentorStatus),
        })}
      </Button>
    );
  }

  if (!mentorStatus || [REJECTED_CAN_REAPPLY].includes(mentorStatus)) {
    if (!currentUser.can_be_a_mentor) {
      mentorStatusButton = null;
    } else {
      mentorStatusButton = (
        <ApplyToBeMentorModal
          customAttributesList={customAttributesList}
          mentorLabel={mentorLabel.toLowerCase()}
          isPreview={isPreview}
        />
      );
    }
  }

  const myMentoringSpace = (
    <MyMentoringLink
      href={Routes.user_mentorships_my_mentors_path(currentUser)}
      // For the Header preview in the user tabs config page
      onClick={
        isPreview
          ? (event) => {
              event.preventDefault();
            }
          : undefined
      }
    >
      <Button isFullWidth variant="secondary">
        {__('Check my %{menu_name} space').i__({
          menu_name: appPageConfig?.menu_name ?? s__('Mentorships|Mentoring'),
        })}
      </Button>
    </MyMentoringLink>
  );

  return { controls: [myMentoringSpace, mentorStatusButton] };
};

export default getMentorshipsHeaderControls;

const MyMentoringLink = styled(DefaultLink)`
  min-width: 0;
  width: 100%;
`;
